module.exports = "https://cdn.thelire.com/ins/resource/pic_friendlyreminder_ios@3x.abc25c32d6165748fa2e3b86527f5234.png";